import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Suraj Thammi </span>
            from Hyderabad, India.
            <br />I am currently enrolled as a sophomore at{" "}
            <span className="purple">CVR College of Engineering</span>, located
            in Hyderabad, pursuing a Bachelor's degree in Computer Science and
            Engineering.
            <br />
            <br />
            Apart from coding, some fun activities that I love to do are
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Listening music
            </li>
            <li className="about-activity">
              <ImPointRight /> Surfing the internet
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
